import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class OnboardService {

    constructor(private httpService: HttpService) { }

    /**
     * Gets activation list
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async saveOnboard(configData: any) {
        return new Promise((resolve, reject) => {
            try {

                let config = this.httpService.setHeaderConfig(true);

                this.httpService.post(UrlConnectionEnum.POST_ONBOARDING, configData, config).subscribe({
                    next: (data) => {
                        resolve(data);
                    },
                    error: (error) => {
                        reject(error);
                    }
                });

            } catch (error) {
                reject(error);
            }
        });
    }

    /**
     * Saves onboard challenge
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async saveOnboardChallenge(configData: any) {
        return new Promise((resolve, reject) => {
            let config = this.httpService.setHeaderConfig(true);

            this.httpService.post(UrlConnectionEnum.POST_STATUS_READ_CHALLENGE, configData, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })
        })
    }


}
